import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  websiteContentIcon,
  seoContentIcon,
  adCopyContentIcon,
  socialMediaContentIcon,
  podcastContentICon,
} from "../../../../assets/icons/serviceIcon/index";
import PersonalBrandingContentWork from "./PersonalBrandingContentWork";

const items = [
  {
    name: "Content Pillar Mapping",
    text: "Organise your brand message into clear themes that make content planning easier and help your audience understand what you truly stand for.",
  },
  {
    name: "Platform Content Calendar",
    text: "Build a personalised weekly or monthly content calendar with topics, formats, and posting plan designed to grow your personal brand steadily.",
  },
  {
    name: "Social Content Creation",
    text: "Develop platform-specific posts, captions, and visuals that communicate your story, showcase your expertise, and position you as a credible personal brand.",
  },
];

const otherService = [
  {
    icon: seoContentIcon,
    name: "Seo Blog Writing",
    des: "Blog posts that teach, tell stories and rank on Google",
    path: "/seo-blog-writing",
  },
  {
    icon: adCopyContentIcon,
    name: "Ad Copy & Sales Funnels",
    des: 'Clear words that guide people from curiosity to clicking "yes"',
    path: "/ad-copy-and-sale-funnels",
  },
  {
    icon: socialMediaContentIcon,
    name: "Social Media Strategy",
    des: "Plan smart, scroll-worthy posts that actually speak to your audience",
    path: "/social-media-strategy",
  },
  {
    icon: websiteContentIcon,
    name: "Website Content",
    des: "Make your website speak your value in the simplest way",
    path: "/website-content",
  },
  {
    icon: podcastContentICon,
    name: "Podcast Scripting & Editing",
    des: "Turn your ideas into podcasts that engage with your audience",
    path: "/podcast-scripting-and-editing",
  },
];
const PersonalBrandingContent = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Content"
        description="Your content should reflect who you are, what you believe, and why people should trust you. We help you show up with clarity, confidence and consistency across every platform."
        heading="Personal Branding"
      />
      <NewCommonServiceForm title="Personal Branding Content" items={items} />
      <PersonalBrandingContentWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PersonalBrandingContent;
